import React, { useEffect, useState } from "react";
import { UrduInput } from "../../../../Components/Shared/UrduInput";
import { UiModal } from "../../../../Components/Shared/UiModal";

const EMPTY_FORM = {
  name: "",
  name_ur: "",
  upto_5_marla: "",
  from_5_to_12_marla: "",
  from_8_to_12_marla: "",
  from_12_to_18_marla: "",
  from_18_to_25_marla: "",
  above_25_marla: "",
};

const MARLA_FIELDS = [
  { name: "upto_5_marla", label: "Up To 5 Marla" },
  { name: "from_5_to_12_marla", label: "From 5 to 12 Marla" },
  { name: "from_8_to_12_marla", label: "From 8 to 12 Marla" },
  { name: "from_12_to_18_marla", label: "From 12 to 18 Marla" },
  { name: "from_18_to_25_marla", label: "From 18 to 25 Marla" },
  { name: "above_25_marla", label: "Above 25 Marla" },
];

const isMarlaField = (name) =>
  MARLA_FIELDS.some((field) => field.name === name);

function ModalAddBuyPlan({ isOpen, onClose, onSubmit, editPlan }) {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!isOpen) {
      setFormData(EMPTY_FORM);
      setErrors({});
      return;
    }

    if (editPlan) {
      setFormData({
        name: editPlan.name || "",
        name_ur: editPlan.name_ur || "",
        upto_5_marla: editPlan.upto_5_marla || "",
        from_5_to_12_marla: editPlan.from_5_to_12_marla || "",
        from_8_to_12_marla: editPlan.from_8_to_12_marla || "",
        from_12_to_18_marla: editPlan.from_12_to_18_marla || "",
        from_18_to_25_marla: editPlan.from_18_to_25_marla || "",
        above_25_marla: editPlan.above_25_marla || "",
      });
    } else {
      setFormData(EMPTY_FORM);
    }
    setErrors({});
  }, [isOpen, editPlan]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (isMarlaField(name) && value !== "" && Number(value) < 0) {
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleMarlaKeyDown = (e) => {
    if (["-", "+", "e", "E"].includes(e.key)) {
      e.preventDefault();
    }
  };

  const validateForm = () => {
    const nextErrors = {};

    MARLA_FIELDS.forEach(({ name }) => {
      const value = formData[name];
      if (value !== "" && Number(value) < 0) {
        nextErrors[name] = "Value cannot be negative";
      }
    });

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    onSubmit(formData, editPlan?.id);
  };

  const isEditMode = Boolean(editPlan);

  return (
    <UiModal
      isOpen={isOpen}
      onClose={onClose}
      eyebrow="Buy Plans"
      title={isEditMode ? "Edit Plan" : "Add Plan"}
      as="form"
      onSubmit={handleSubmit}
      footer={
        <>
          <button
            type="button"
            className="ui-btn-cancel min-w-[108px]"
            onClick={onClose}
          >
            Cancel
          </button>
          <button type="submit" className="ui-btn-save min-w-[108px]">
            {isEditMode ? "Update" : "Save"}
          </button>
        </>
      }
    >
      <section className="ui-modal-section">
        <h4 className="ui-modal-section-title">Plan details</h4>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label className="ui-form-label">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="ui-input-field"
              placeholder="Enter name"
            />
          </div>
          <UrduInput
            label="نام"
            name="name_ur"
            value={formData.name_ur}
            onChange={handleChange}
            className=""
          />
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {MARLA_FIELDS.map(({ name, label }) => (
            <div key={name}>
              <label className="ui-form-label">{label}</label>
              <input
                type="number"
                name={name}
                min="0"
                step="any"
                value={formData[name]}
                onChange={handleChange}
                onKeyDown={handleMarlaKeyDown}
                className={`ui-input-field ${
                  errors[name] ? "border-brand-error" : ""
                }`}
                placeholder="Enter value"
                dir="ltr"
              />
              {errors[name] ? (
                <p className="ui-form-error">{errors[name]}</p>
              ) : null}
            </div>
          ))}
        </div>
      </section>
    </UiModal>
  );
}

export default ModalAddBuyPlan;
